import { render } from "./ResultsRecentlyOpened.vue?vue&type=template&id=1dc85b6c&scoped=true"
import script from "./ResultsRecentlyOpened.vue?vue&type=script&lang=js"
export * from "./ResultsRecentlyOpened.vue?vue&type=script&lang=js"

import "./ResultsRecentlyOpened.vue?vue&type=style&index=0&id=1dc85b6c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc85b6c"]])

export default __exports__